import {
  CircleCheck,
  CircleDot,
  CircleX,
  CloudOff,
  History,
  Inbox,
  LoaderCircle,
  LockKeyhole,
  ShieldX,
  TriangleAlert,
  type LucideIcon,
} from 'lucide-react';

export type StatusState =
  | 'loading'
  | 'ready'
  | 'empty'
  | 'zero'
  | 'blocked'
  | 'failed'
  | 'denied'
  | 'stale'
  | 'unavailable'
  | 'invalid';

export const statusLabel: Record<StatusState, string> = {
  loading: 'Loading',
  ready: 'Ready',
  empty: 'Empty',
  zero: 'Zero',
  blocked: 'Blocked',
  failed: 'Failed',
  denied: 'Access denied',
  stale: 'Last known',
  unavailable: 'Unavailable',
  invalid: 'Check input',
};

export const statusIcon: Record<StatusState, LucideIcon> = {
  loading: LoaderCircle,
  ready: CircleCheck,
  empty: Inbox,
  zero: CircleDot,
  blocked: LockKeyhole,
  failed: CircleX,
  denied: ShieldX,
  stale: History,
  unavailable: CloudOff,
  invalid: TriangleAlert,
};

export const statusClass: Record<StatusState, string> = {
  loading:
    'border-status-loading-border bg-status-loading-surface text-status-loading',
  ready: 'border-status-ready-border bg-status-ready-surface text-status-ready',
  empty:
    'border-status-neutral-border bg-status-neutral-surface text-status-neutral',
  zero: 'border-status-neutral-border bg-status-neutral-surface text-status-neutral',
  blocked:
    'border-status-blocked-border bg-status-blocked-surface text-status-blocked',
  failed:
    'border-status-failed-border bg-status-failed-surface text-status-failed',
  denied:
    'border-status-denied-border bg-status-denied-surface text-status-denied',
  stale: 'border-status-stale-border bg-status-stale-surface text-status-stale',
  unavailable:
    'border-status-unavailable-border bg-status-unavailable-surface text-status-unavailable',
  invalid:
    'border-status-invalid-border bg-status-invalid-surface text-status-invalid',
};
